module.exports = __webpack_public_path__ + "static/full05-e20d0ab9423b9b3ef0970152c63e9f68.png";